import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class MessageHomeService {
  private pendingMessage: any = null;

  constructor(private messageService: MessageService) { }

  showSuccessAndNavigate(router: Router, route: string, summary: string, detail: string) {
    this.pendingMessage = {
      severity: 'success',
      summary,
      detail,
      life: 5000
    };
    router.navigate([route]);
  }

  checkAndShowPendingMessage() {
    if (this.pendingMessage) {
      this.messageService.add(this.pendingMessage);
      this.pendingMessage = null;
    }
  }
}
